import { useDocumentTitle, siteTitle } from "@1-now/booking-core";
import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { useData } from "data/data-provider";

export interface ListingCarPageProps {
  className?: string;
}

const ListingCarPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { companyDetails } = useData();
  // "Vehicles — <operator>", always (1NOW-11189, Faiza 7 Oct). It used to be the operator's
  // SEO title whenever one was set, so Vehicles read as the home page's title. The SEO title is
  // the site's title: the header gives it to every page that has none of its own.
  useDocumentTitle(companyDetails ? siteTitle(companyDetails, "Vehicles") : undefined);
  return (
    <div
      className={`nc-ListingCarPage relative ${className}`}
      data-nc-id="ListingCarPage"
    >
      <div className="container relative">
        <SectionGridFilterCard className="pt-8 pb-20 sm:pt-10 lg:pb-24" />
      </div>
    </div>
  );
};

export default ListingCarPage;
